// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"8edcf699","774":"6de2e430"}[chunkId] + ".chunk.css";
};